import React, { useEffect } from 'react'
import { Router, Route, Switch, Redirect } from 'react-router-dom'
import App from 'Containers/App/index'
import Login from 'Containers/Auth/Login'
import { clearAllFilters } from 'Reducers/Filter/actions'
import { FeatureFlagsContextProvider } from '../../Context/FeatureFlagsContext'
import Logout from 'Containers/Auth/Logout'
import ForgotPassword from 'Containers/Auth/ForgotPassword'
import ResetPassword from 'Containers/Auth/ResetPassword'
import ResetPasswordSuccess from 'Components/Auth/ResetPasswordSuccess'
import VerifyEmail from 'Components/Auth/VerifyEmail'
import SnackBar from 'Components/SnackBar'
import { PostHogProviderWrapper } from 'Components/PostHogProvider'
import APIErrorModal from './../../Containers/APIErrorHandler'
import store from 'Config/store'
import { PATHS } from 'Config/Routing/paths'
import { history } from 'Config/history'
import Zendesk from './../../Containers/Zendesk'
import { PrivateRoute } from './auth'
import NpsScoreVoterPage from '../../Containers/NpsScoreVotedPage'
import SignUp from '../../Containers/Auth/SignUp'
import AuthErrorPage from '../../Components/Errors/Errors'
import AuthCallback from '../../Containers/Auth/OAuth2Callback/AuthCallback'
import MergeCallback from '../../Containers/Auth/OAuth2Callback/MergeCallback'
import SignUpCallback from '../../Containers/Auth/OAuth2Callback/SignUpCallback'
import OAuth2FailureCallback from '../../Containers/Auth/OAuth2Callback/OAuth2FailureCallback'
import { loadGTM } from '../../Utils/Analytics/gtmLoader'

export const MainRouter = () => {
  useEffect(() => {
    let lastRoute = null
    history.listen(location => {
      if (location.pathname !== lastRoute) {
        store.dispatch(clearAllFilters())
      }
      lastRoute = location.pathname
    })
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const oppiziSource = params.get('oppizi_source')

    if (oppiziSource === 'eddm') {
      loadGTM('GTM-K535PLVV')
    } else {
      loadGTM('TVBX5KQ', 'https://sgtm.oppizi.com/pqtwjlgp.js?st=TVBX5KQ')
    }
  }, [])

  return (
    <div>
      <PostHogProviderWrapper>
        <SnackBar>
          <Router history={history}>
            <Zendesk>
              <Switch>
                <Route path={PATHS.main.login} component={Login} />
                <Route path={PATHS.main.logout} component={Logout} />
                <Route path={PATHS.main.signUp} component={SignUp} />
                <Route
                  path={PATHS.main.oAuth2Callback}
                  component={AuthCallback}
                />
                <Route
                  path={PATHS.main.oAuth2CallbackMerge}
                  component={MergeCallback}
                />
                <Route
                  path={PATHS.main.oAuth2ErrorCallback}
                  component={OAuth2FailureCallback}
                />
                <Route
                  path={PATHS.main.signUpOAuth2CallbackMerge}
                  component={SignUpCallback}
                />
                <Route
                  path={PATHS.main.requestPass}
                  component={ForgotPassword}
                />
                <Route path={PATHS.main.resetPass} component={ResetPassword} />
                <Route
                  path={PATHS.main.resetPassSuccess}
                  component={ResetPasswordSuccess}
                />
                <Route path={PATHS.main.verifyEmail} component={VerifyEmail} />
                <Route
                  path={PATHS.main.npsScore}
                  component={NpsScoreVoterPage}
                />
                <Route path={PATHS.main.dashboard}>
                  <PrivateRoute>
                    <FeatureFlagsContextProvider>
                      <App />
                    </FeatureFlagsContextProvider>
                  </PrivateRoute>
                </Route>
                <Route path={PATHS.main.errors} component={AuthErrorPage} />
                <Redirect from="/" to={PATHS.main.dashboard} />
              </Switch>
            </Zendesk>
          </Router>
          <APIErrorModal />
        </SnackBar>
      </PostHogProviderWrapper>
    </div>
  )
}
